
const controleren = {

	init() {

		// Bind opmerkingen select fuctie aan select
		$('body').on('change', '.toelichting-keuze', function(e) {
			$(e.target).closest('.modal').find('.toelichting').val(e.target.value);
			controleren.disableIfEmpty($('.modal [type=submit]'), e.target.value);
		});

	},

	// Disabled button if value is empty or not set
	disableIfEmpty: function(t, v) {
		t.prop('disabled', true);
		if (v !== null || v !== '') {
			t.prop('disabled', false);
		}
	}

};

export default controleren;
